import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import { GeoFirestore, } from 'geofirestore'
import { firebaseConfig, } from 'config/firebaseConfig'

export default !firebase.apps.length
  ? firebase.initializeApp(firebaseConfig)
  : firebase.app()

export const auth = firebase.auth()
export const firestore = firebase.firestore()
export const storage = firebase.storage()
export const geofirestore = new GeoFirestore(firestore)
